import { Chip } from '@mui/material';
import { FMT } from '@foresightdata/web-common-formatter-service';

export function FyeChip({ fye }: { fye: number }) {
  return (
    <Chip aria-label={'fye'} size={'medium'} label={`FYE: ${FMT.format('fye', fye)}`} variant='outlined' />
  );
}
